export default {"src":"/_next/static/media/edit.b8be5781.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};